import {ArtfactKind, EnvironmentKind} from '@mrp-brasil/nick-data-commons';
import {BaseHook, Hook, HookClass, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import {Observable, of} from 'rxjs';
import {concatMap, map} from 'rxjs/operators';
import {HttpHook} from '../http/http.hook';
import moment from 'moment';

@HookClass('payFiscal')
export class PayFiscalHook extends BaseHook {

    @Hook('b7ecf933-fce3-4d7d-b3a1-258574983100')
    public createCert(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.make<HttpHook>(HttpHook)
            .pipe(concatMap((httpHook: HttpHook) => {
                return this.settings
                    .pipe(concatMap((settings: any) => {

                        const endpoint = settings.environment == EnvironmentKind.DEV
                            ? 'https://app.local.nickbuilder.com.br/api/process/start/new'
                            : 'https://pay.fluna.io/api/process/start/new';


                        const httpArtifact = new NickProcessArtfact();
                        httpArtifact.kind = ArtfactKind.ANY;
                        httpArtifact.object = {
                            config: {
                                url: `${endpoint}/2c45add2-78c3-427f-a9b2-88c3b6107e05`,
                                params: {},
                                headers: {
                                    'nick-system': 'c45606f4-a9c9-48cd-b63f-8c1ddca7c2f8'
                                },
                                body: {
                                    certificate: inputArtifact.object.certificate,
                                    password: inputArtifact.object.password,
                                    establishmentId: inputArtifact.object.establishmentId
                                }
                            }
                        };

                        return httpHook.postExternal(httpArtifact);
                    }));
            }))
            .pipe(map((response: NickProcessArtfact) => {
                return response;
            }));
    }

    @Hook('38525fec-351b-47bf-aa11-4780f132713b')
    public createEnterprise(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.make<HttpHook>(HttpHook)
            .pipe(concatMap((httpHook: HttpHook) => {
                return this.settings
                    .pipe(concatMap((settings: any) => {

                        const endpoint = settings.environment == EnvironmentKind.DEV
                            ? 'https://app.local.nickbuilder.com.br/api/process/start/new'
                            : 'https://pay.fluna.io/api/process/start/new';


                        const httpArtifact = new NickProcessArtfact();
                        httpArtifact.kind = ArtfactKind.ANY;
                        httpArtifact.object = {
                            config: {
                                url: `${endpoint}/2a187a6f-a9b0-43c7-9bf2-26b2db68f5d4`,
                                params: {},
                                headers: {
                                    'nick-system': 'c45606f4-a9c9-48cd-b63f-8c1ddca7c2f8'
                                },
                                body: {
                                    cpfCnpj: inputArtifact.object.cpfCnpj,
                                    inscricaoMunicipal: inputArtifact.object.inscricaoMunicipal,
                                    inscricaoEstadual: inputArtifact.object.inscricaoEstadual,
                                    razaoSocial: inputArtifact.object.razaoSocial,
                                    nomeFantasia: inputArtifact.object.nomeFantasia,
                                    certificado: inputArtifact.object.certificado,
                                    simplesNacional: inputArtifact.object.simplesNacional,
                                    regimeTributario: inputArtifact.object.regimeTributario,
                                    incentivoFiscal: inputArtifact.object.incentivoFiscal,
                                    incentivadorCultural: inputArtifact.object.incentivadorCultural,
                                    regimeTributarioEspecial: inputArtifact.object.regimeTributarioEspecial,
                                    endereco: {
                                        tipoLogradouro: inputArtifact.object.endereco.tipoLogradouro,
                                        logradouro: inputArtifact.object.endereco.logradouro,
                                        numero: inputArtifact.object.endereco.numero,
                                        complemento: inputArtifact.object.endereco.complemento,
                                        tipoBairro: inputArtifact.object.endereco.tipoBairro,
                                        bairro: inputArtifact.object.endereco.bairro,
                                        codigoPais: inputArtifact.object.endereco.codigoPais,
                                        descricaoPais: inputArtifact.object.endereco.descricaoPais,
                                        codigoCidade: inputArtifact.object.endereco.codigoCidade,
                                        descricaoCidade: inputArtifact.object.endereco.descricaoCidade,
                                        estado: inputArtifact.object.endereco.estado,
                                        cep: inputArtifact.object.endereco.cep
                                    },
                                    telefone: {
                                        ddd: inputArtifact.object.telefone.ddd,
                                        numero: inputArtifact.object.telefone.numero
                                    },
                                    email: inputArtifact.object.email,
                                    nfe: {
                                        ativo: inputArtifact.object.nfe.ativo,
                                        tipoContrato: inputArtifact.object.nfe.tipoContrato,
                                        config: {
                                            producao: inputArtifact.object.nfe.config.producao,
                                            impressaoFcp: inputArtifact.object.nfe.config.impressaoFcp,
                                            impressaoPartilha: inputArtifact.object.nfe.config.impressaoPartilha,
                                            serie: inputArtifact.object.nfe.config.serie,
                                            numero: inputArtifact.object.nfe.config.numero
                                        }
                                    },
                                    establishmentId: inputArtifact.object.establishmentId
                                }
                            }
                        };

                        return httpHook.postExternal(httpArtifact);
                    }));
            }))
            .pipe(map((response: NickProcessArtfact) => {
                return response;
            }));
    }

    @Hook('ccc8fce8-b938-4a34-91b1-e696f78274bb')
    public createNFe(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.make<HttpHook>(HttpHook)
            .pipe(concatMap((httpHook: HttpHook) => {
                return this.settings
                    .pipe(concatMap((settings: any) => {

                        const endpoint = settings.environment == EnvironmentKind.DEV
                            ? 'https://app.local.nickbuilder.com.br/api/process/start/new'
                            : 'https://pay.fluna.io/api/process/start/new';


                        const httpArtifact = new NickProcessArtfact();
                        httpArtifact.kind = ArtfactKind.ANY;
                        httpArtifact.object = {
                            config: {
                                url: `${endpoint}/ef55792b-43f4-4d06-90ff-81c4ba8b27b6`,
                                params: {},
                                headers: {
                                    'nick-system': 'c45606f4-a9c9-48cd-b63f-8c1ddca7c2f8'
                                },
                                body: {
                                    notas: inputArtifact.object.notas,
                                    establishmentId: inputArtifact.object.establishmentId
                                }
                            }
                        };

                        return httpHook.postExternal(httpArtifact);
                    }));
            }))
            .pipe(map((response: NickProcessArtfact) => {
                return response;
            }));
    }
}
